export const COLORS = {
  // base
  primary: '#015989',
  secondary: '#383b3b',
  white: '#fff',
  background: '#fff',
  black: '#000',
  hover: 'rgb(222, 222, 222)',

  // selection list
  selectedDiv: 'rgba(50, 50, 250, 0.1)',
  hoveredDiv: 'rgba(50, 50, 250, 0.1)',
  selectedIcon: '#0341b6',
  unselected: 'rgba(0, 0, 0, 0.6)',
  available: '#78d78d',
  unavailable: 'rgba(0, 0, 0, 0.17)',
  busy: 'rgb(252, 112, 24)',
  maintenance: '#28467d',

  //
  transparentIcon: 'rgba(0, 0, 0, 0.17)',
  transparentDark: 'rgba(0, 0, 0, 0.05)',
  lightDarkText: 'rgba(0, 0, 0, 0.7)',
  red: '#fd5d5d',
  lightBlueBackground: '#1774ff1f',
  stone: '#d9d9d9',

  // indicators charts
  duration: '#2C29D0',
  recharges: '#2288E7',
  consume: '#21C6EA',
  autonomy: '#30CB6E',
  stayTime: '#AEDE49',
  popular: '#1ABF0B',
  carBrandUsage: '#EA0000',

  // Transactions: amount status
  amountStatusPaid: '#78d78d',
  amountStatusNotPaid: '#fd5d5d',
  amountStatusInformation: '#1890ff',
};
